import { useQuery } from '@tanstack/react-query'

import { defaultApiHost } from '@src/helpers'

import { handleResponse } from '../services/rest/apiService'
import type { ChatChannelConfig } from '../services/rest/types'

/**
 * Hook to fetch chat channel configuration.
 */
export const useChatChannelQuery = (
  chatChannelId: string | undefined,
  apiHost = defaultApiHost,
) => {
  const query = useQuery<ChatChannelConfig>({
    queryKey: ['getChatChannelConfig', { chatChannelId, apiHost }],
    queryFn: async () => {
      const response = await fetch(
        `${apiHost}/api/chat_channels/${chatChannelId}`,
      )
      return handleResponse(response)
    },
    retry: false,
    enabled: !!chatChannelId,
  })

  return query
}
